import React, { useState } from 'react'
import './activism-pillars-accordion.css'

export default function ActivismPillarsAccordion() {
  const [activeIndex, setActiveIndex] = useState(null)

  const pillars = [
    {
      id: 1,
      title: 'Transformación de las narrativas hegemónicas',
      content: 'Desafiamos y erradicamos el estigma, el silencio y la vergüenza que históricamente han rodeado a la menstruación, convirtiendo lo íntimo en una conversación política, académica y comunitaria.'
    },
    {
      id: 2,
      title: 'Menstruación, ciclo y menopausia',
      content: 'Impulsamos su presencia en la agenda pública y en los diálogos cotidianos para avanzar en atención sanitaria integral, justicia ecosocial y erradicar tabúes inferiorizantes.'
    },
    {
      id: 3,
      title: 'Reivindicación de derechos humanos',
      content: 'Entendemos la menstruación como una cuestión de derechos humanos, exigiendo a los Estados garantizar acceso equitativo a educación, salud y productos de gestión menstrual.'
    },
    {
      id: 4,
      title: 'Incidencia política y legislativa',
      content: 'Impulsamos la aplicación de la Ley Orgánica 1/2023 para que las políticas de equidad y dignidad menstrual se implementen de forma efectiva en todos los territorios.'
    },
    {
      id: 5,
      title: 'Altavoz de violencias en salud sexual y reproductiva',
      content: 'Amplificamos a colectivos afectados por endometriosis, el dispositivo Essure y otras violencias médicas y farmacéuticas.'
    },
    {
      id: 6,
      title: 'Acción pública y visibilización',
      content: 'Generamos sensibilización urbana mediante acciones como los Puntos Rojos.'
    },
    {
      id: 7,
      title: 'Postura crítica y anticapitalista',
      content: 'Cuestionamos la instrumentalización de la menstruación por parte de multinacionales, denunciamos el marketing rosa y el menowashing vinculado a la menopausia.'
    },
    {
      id: 8,
      title: 'Producción de conocimiento y ciberactivismo',
      content: 'Desarrollamos investigación feminista situada y mejoramos la representación de la educación y la salud menstrual en Wikipedia.'
    },
    {
      id: 9,
      title: 'Activismo colectivo e internacional',
      content: 'Tejemos redes con entidades y colectivos de otros territorios y participamos en campañas como #MenstrualMattersEU y #DiaMundialMenarquia.'
    }
  ]

  const togglePillar = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <div className='activism-accordion'>
      {pillars.map((pillar, index) => (
        <div key={pillar.id} className='activism-accordion__item'>
          <button
            className='activism-accordion__header'
            onClick={() => togglePillar(index)}
            aria-expanded={activeIndex === index}
          >
            <span className='activism-accordion__title'>{pillar.title}</span>
            <span className='activism-accordion__toggle'>
              {activeIndex === index ? '−' : '+'}
            </span>
          </button>
          {activeIndex === index && (
            <div className='activism-accordion__content'>
              <p className='activism-accordion__text'>{pillar.content}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
